module.exports = __webpack_public_path__ + "img/logo_xedu.35f04294.svg";